import { CARD_GRID_CLS } from "./Card.js";

export function SkeletonCard() {
  return (
    <div
      className="flex h-full min-h-[7.5rem] flex-col rounded-2xl border border-line bg-surface p-5 shadow-sm"
      aria-hidden="true"
    >
      <div className="h-5 w-2/3 animate-pulse rounded-lg bg-slate-200" />
      <div className="mt-3 h-3 w-full animate-pulse rounded-lg bg-slate-100" />
      <div className="mt-2 h-3 w-4/5 animate-pulse rounded-lg bg-slate-100" />
      <div className="mt-4 h-3 w-1/3 animate-pulse rounded-lg bg-slate-100" />
    </div>
  );
}

export function SkeletonCardGrid({ count = 3 }: { count?: number }) {
  return (
    <ul className={`mt-6 ${CARD_GRID_CLS}`} aria-busy="true" aria-label="Loading">
      {Array.from({ length: count }, (_, i) => (
        <li key={i}>
          <SkeletonCard />
        </li>
      ))}
    </ul>
  );
}
